
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 187 180","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M136 50.21a41.68 41.68 0 1041.91 41.67A41.79 41.79 0 00136 50.21v0z","stroke":"#212524","stroke-width":"2.47","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M134.18 142.57c.6 0 1.09-1.31 1.09-2.91V44.1c0-1.6-.49-2.91-1.09-2.91H17.49c-.59 0-1.08 1.31-1.08 2.91v95.56c0 1.6.49 2.91 1.08 2.91h116.69z","fill":"#00577B"}}),_c('path',{attrs:{"d":"M134.18 142.57c.6 0 1.09-1.31 1.09-2.91V44.1c0-1.6-.49-2.91-1.09-2.91H17.49c-.59 0-1.08 1.31-1.08 2.91v95.56c0 1.6.49 2.91 1.08 2.91h116.69z","stroke":"#00577B","stroke-width":".82"}}),_c('path',{attrs:{"d":"M37.05 42.23l-19.6 99.3m116.78 0l-19.6-99.3 19.6 99.3zm0-99.3l-19.6 99.3 19.6-99.3zm-19.47 99.3l-19.6-99.3 19.6 99.3zm0-99.3l-19.6 99.3 19.6-99.3zm-19.64 99.3l-19.6-99.3 19.6 99.3zm0-99.3l-19.6 99.3 19.6-99.3zm-19.95 99.3l-19.59-99.3 19.59 99.3zm0-99.3l-19.59 99.3 19.59-99.3zM56 141.53l-19.59-99.3L56 141.53zm0-99.3l-19.59 99.3L56 42.23zm-18.95 99.3l-19.6-99.3 19.6 99.3z","stroke":"#212524","stroke-width":"2.06","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    